// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';
import Modal from './Modal';
import api from '../../api';

export default class ForgotPassword extends Modal {

    state = {
        email: ""
    }

    resetPassword = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const userEmail = this.state.email;

        if (!userEmail || userEmail === "" || !userEmail.includes("@"))
            return this.alert();

        await this.props.modal();
        await this.props.loading();
        const res = await api.post('/user/forgotPassword', { userEmail });
        if (res && res.success)
            toast.info("Check your email for a reset link!");
        await this.setState({ email: "" });
        this.props.loaded();
    }

    renderContent = () => {

        return (<div className="modal-content modal-center">
            
            <br /><br />

            <h1>Uh Oh!</h1>

            <h2>Don't worry, we can help.</h2>

            <p>
                Enter your email address below and hit "Reset password" to change your password.<br />
                You will receive an email with a link to reset your account password. Update your password to a secure and memorable password using the link.
            </p>

            <br />

            <h2>What's the user's email address?</h2>

            <form onSubmit={this.resetPassword}>

                <input
                    id="email"
                    name="email"
                    type="text"
                    className={"input-inline-text" + (this.state.alert ? " input-error" : "")}
                    placeholder="Enter email address..."
                    style={{ width: 330 }}
                    value={this.state.email}
                    onClick={e => e.stopPropagation()}
                    onChange={e => this.setState({ email: e.target.value, alert: false })}
                />

                <input
                    type="submit"
                    value="Reset Password"
                    className="input-inline-submit"
                />
            
            </form>
            
        </div>);
    }

};